import { Component, OnInit } from '@angular/core';
import {DisplayedColumnInf} from '../../../interfaces/common/table/displayed-column-inf';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {PageEvent} from '@angular/material/paginator';
import {NtpServersApiService} from '../../../services/api/settings/network-services/ntp/ntp-servers-api.service';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import {LogicalConjunctionService} from '../../../services/common/logical-conjunction/logical-conjunction.service';
import {AcDialogService} from 'ac-infra';
import {NtpDialogComponent} from './ntp-dialog/ntp-dialog.component';

@Component({
  selector: 'ntp',
  templateUrl: './ntp.component.html',
  styleUrls: ['./ntp.component.scss']
})
export class NtpComponent implements OnInit {

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'serverName', display: 'Server name', selected: true, width: 200},
    {name: 'address', display: 'Address', selected: true, width: 200},

  ];
  items;
  isMultipleSelection: false;
  selection;
  isUnauthorized: boolean;

  constructor(private userPrivilege: UserPrivilegeService,
              private ntpServersApiService: NtpServersApiService, public dialog: MatDialog,
              private snackBarService: SnackBarService, private logicalConjunctionService: LogicalConjunctionService,
              private dialogService: AcDialogService) { }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized();
    this.refresh();
  }

  editItem(): void {
    const selectedNTPServer = this.selection.id;

    this.ntpServersApiService.getNTPServer(selectedNTPServer).subscribe(serverToEdit => {
      this.dialogService.open(NtpDialogComponent, {
        dialogData: serverToEdit,
        title: 'Edit NTP server',
        onSubmit: () => {
          return   this.ntpServersApiService.editNTPServer(serverToEdit, selectedNTPServer ).toPromise().then(() => {
            this.refresh();
          });

        },
      });

  });
  }

  addItem(): void {

    const newNTPServer = {
      serverName: ''
    };

    this.dialogService.open(NtpDialogComponent, {
      dialogData: newNTPServer,
      title: 'Add NTP server',
      onSubmit: () => {
        return   this.ntpServersApiService.addNTPServer(newNTPServer).toPromise().then(() => {
          this.refresh();
        });

      },
    });
  }

  removeItem(): void {
    const confirmationMessage = `Are you sure you want to delete the NTP server: "${this.selection.serverName}" ?`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: confirmationMessage
      }
    });


    dialogRef.componentInstance.onApply.subscribe(() => {
      this.ntpServersApiService.deleteNTPServer(this.selection.id).subscribe(() => {
        dialogRef.close();
        this.refresh();
        this.snackBarService.display(`${this.logicalConjunctionService
          .generateAndDescription(this.selection, 'name')} successfully deleted`);
      });
    });

  }

  pageChanged($event: PageEvent) {

  }

  onSelection(selection: any): void {
    this.selection = selection;
  }

  refresh(): void {
    this.ntpServersApiService.getNTPServers().subscribe(data => {
      this.items = data;
    });
  }

}
